/* eslint-disable no-unused-expressions */
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";

// core components
import GridContainer from "../../componentsMaterial/Grid/GridContainer.jsx";
import GridItem from "../../componentsMaterial/Grid/GridItem.jsx";
import Button from "../../componentsMaterial/CustomButtons/Button.jsx";
import CustomInput from "../../componentsMaterial/CustomInput/CustomInput.jsx";
import Clearfix from "../../componentsMaterial/Clearfix/Clearfix.jsx";
import Card from "../../componentsMaterial/Card/Card.jsx";
import CardBody from "../../componentsMaterial/Card/CardBody.jsx";
import CardHeader from "../../componentsMaterial/Card/CardHeader.jsx";
import CardIcon from "../../componentsMaterial/Card/CardIcon.jsx";
import CardAvatar from "../../componentsMaterial/Card/CardAvatar.jsx";
import ImageUpload from "../../componentsMaterial/CustomUpload/ImageUpload.jsx";
import organizationActions from '../../redux/organization/actions'

import userProfileStyles from "./userProfileStyles";
// redux
import { connect } from 'react-redux'
import authActions from '../../redux/auth/actions'


const dataRank = [{
  "rank_id": 0,
  "rank_name": "Binh nhì"
},
{
  "rank_id": 1,
  "rank_name": "Binh nhất"
},
{
  "rank_id": 2,
  "rank_name": "Hạ sĩ"
},
{
  "rank_id": 3,
  "rank_name": "Trung sĩ"
},
{
  "rank_id": 4,
  "rank_name": "Thượng sĩ"
},
{
  "rank_id": 5,
  "rank_name": "Học viên"
},
{
  "rank_id": 6,
  "rank_name": "Thiếu úy"
},
{
  "rank_id": 7,
  "rank_name": "Trung úy"
},
{
  "rank_id": 8,
  "rank_name": "Thượng úy"
},
{
  "rank_id": 9,
  "rank_name": "Đại úy"
},
{
  "rank_id": 10,
  "rank_name": "Thiếu tá"
},
{
  "rank_id": 11,
  "rank_name": "Trung tá"
},
{
  "rank_id": 12,
  "rank_name": "Thượng tá"
},
{
  "rank_id": 13,
  "rank_name": "Đại tá"
},
{
  "rank_id": 14,
  "rank_name": "Thiếu tướng"
},
{
  "rank_id": 15,
  "rank_name": "Trung tướng"
},
{
  "rank_id": 16,
  "rank_name": "Thượng tướng"
},
{
  "rank_id": 17,
  "rank_name": "Đại tướng"
}]

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      displayName: '',
      position: 0,
      organ_id: null,
      tier_id: 0,
      enableSubmit: false,
      email: '',
      phone: '',
      rank: 0,
    }
    this.imgUpload = React.createRef();
  }
  componentDidMount() {
    const loadType = organizationActions.loadType.GET_NOT_DELETED
    this.props.loadListOrganizations(loadType)
  }
  
  handleSimple = event => {
    this.setState({ organ_id: event.target.value, enableSubmit:true });
  };
  submitForm = () =>{
    const { userInfo, updateUserInfo } = this.props
    const {displayName ,position,organ_id,tier_id} = this.state
    console.log('user info', userInfo);
    const data = {}
    if(displayName === ''){
      Object.assign(data, {'display_name': userInfo.display_name});      
    }else{
      Object.assign(data, {'display_name': displayName});      
    }
    if(position === 0){
      Object.assign(data, {'position': userInfo.position});      

    }else{
      Object.assign(data, {'position': position});      
    }
    if(organ_id === null){
      Object.assign(data, {'organ_id': userInfo.organ_id});      
    }else{
      Object.assign(data, {'organ_id': organ_id});      
    }
    if(tier_id === 0){
      Object.assign(data, {'tier_id': userInfo.tier_id});      

    }else{
      Object.assign(data, {'tier_id': tier_id});      
    }
    if(this.imgUpload.current.getUrlUpload() === null){
      Object.assign(data, {'avatar':  userInfo.avatar});      
    }else{
      Object.assign(data, {'avatar': this.imgUpload.current.getUrlUpload()});      
    }
    if(this.state.email === ''){
      Object.assign(data, {'email':  userInfo.email});      
    }else{
      Object.assign(data, {'email': this.state.email });      
    }
    if(this.state.phone === ''){
      Object.assign(data, {'phone':  userInfo.phone});    
    }else{
      Object.assign(data, {'phone':  this.state.phone});    

    }
    Object.assign(data, {'status': userInfo.status });      

    Object.assign(data, {'pubkey': userInfo.pubkey ? userInfo.pubkey : '' });      
    Object.assign(data, {'roles': userInfo.roles ? userInfo.roles : []});      
    console.log('')
    updateUserInfo(userInfo.uid, data);
    
  }
  getTierIdName = (tierid) =>{
    switch(tierid){
      case 1:
        return 'Tier_1'
      case 2: 
        return 'Tier_2'
      case 3: 
        return 'Tier_3'
      case 4: 
        return 'Người dùng đơn vị vùng'
      case 90:
        return 'Admin'
      case 100:
        return 'Super admin'
      default: return ''
    }
  }
  getPositionName = (pos) =>{
    switch(pos){
      case 1:
        return 'Cấp trưởng'
      case 2: 
        return 'Cấp phó'
      case 3: 
        return 'Nhân viên'
      
      default: return ''
    }
  }
  getStausName = (status) =>{
    switch(status){
      case 1:
        return 'Đã kích hoạt'
      case 2: 
        return 'Đã cấm'
      case 3: 
        return 'Đã xóa'
      
      default: return ''
    }
  }
  getRankName =(id) =>{
   let rankName =  dataRank.find(value => {
      return value = value.rank_id
    })
    return rankName.rank_name
  }

  render(){
  const { classes } = this.props;
  const { userInfo, organizations } = this.props;


  if(userInfo!== null && organizations !== null ){    
    return (
      
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Thông tin cá nhân
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Họ và tên"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        defaultValue : userInfo ? userInfo.display_name : '',
                        onChange: event => this.setState({displayName: event.target.value, enableSubmit: true }),

                      }}
                    />
                  </GridItem> 
                </GridContainer>
                <GridContainer>                    
                  <GridItem xs={12} sm={6} md={5} lg={5}>
                        <FormControl
                          fullWidth
                          className={classes.selectFormControl}
                        >
                          <InputLabel
                            htmlFor="simple-select"
                            className={classes.selectLabel}
                          >
                            Chọn đơn vị
                          </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.organ_id === null ? userInfo.organ_id : this.state.organ_id}
                            onChange={this.handleSimple}
                            inputProps={{
                              name: "simpleSelect",
                              id: "simple-select",
                              disabled: true

                            }}
                          >
                            {organizations.map(value =>(
                              <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                    selected: classes.selectMenuItemSelected
                                  }}
                                  value={value.oid}
                                >
                                  {value.name}
                              </MenuItem>
                            ))}
                          
                          
                          </Select>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={3} md={5} lg={5}></GridItem>
                  
                  
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Trạng thái tài khoản"
                      id="first-name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      
                      inputProps={{
                        defaultValue: this.getStausName(userInfo.status),
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Loại người dùng"
                      id="last-name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        defaultValue: this.getTierIdName(userInfo.tier_id) ,
                        onChange: event => this.setState({tier_id: event.target.value, enableSubmit: true }),
                        disabled: true

                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Vị trí"
                      id="username"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        defaultValue: this.getPositionName(userInfo.position),
                        onChange: event => this.setState({position:event.target.value, enableSubmit: true }),
                        disabled: true

                      }}
                    />
                  </GridItem>
                </GridContainer>
                
                <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Email"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        defaultValue: userInfo.email,
                        onChange: email => this.setState({email:email.target.value, enableSubmit: true }),

                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Số điện thoại"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        defaultValue: userInfo.phone,
                        onChange: phone => this.setState({phone:phone.target.value, enableSubmit: true }),

                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                      labelText="Quân hàm"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        defaultValue: this.getRankName(userInfo.rank_id),
                        disabled: true
                      }}
                    />
                  </GridItem>
                </GridContainer>

                
                <Button color={this.state.enableSubmit ? "info" : 'gray'} className={classes.updateProfileButton} onClick={this.submitForm} disabled={!this.state.enableSubmit}>
                  Cập nhật 
                </Button>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              {/* <CardAvatar plain > */}
                {/* <a href="#pablo" onClick={e => e.preventDefault()}>
                  <img src={avatar} alt="..." />
                </a> */}
                <ImageUpload
                  ref ={this.imgUpload}
                  doUpload ={()=> {this.setState({enableSubmit:true})}}
                  avatar={userInfo.avatar}
                  addButtonProps={{
                    color: "info",
                    round: true,
                    size: "sm",
                    
                  }}
                  
                  />
              {/* </CardAvatar> */}
              <CardBody formHorizontal>
                <h5 className={classes.cardCategory}> </h5>
                <h4 className={classes.cardTitle}>{userInfo ? userInfo.display_name : ""}</h4>
                
                
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );

  } else{
    return(<div>Đang tải dữ liệu. . .</div>)
  }
  
    
  }
  
}

UserProfile.propTypes = {
  classes: PropTypes.object
};
const mapStateToProps = state => {
  return {
      userInfo: state.auth.userInfo,
      isLogin: state.home.isLogin,
      organizations: state.organization.organizations
  }
}

const mapDispatchToProps = dispatch => {
  return {
      updateUserInfo: (uid, body) => {
          dispatch(authActions.action.updateUserInfo(uid, body))
      },
      loadListOrganizations: loadType => {
        dispatch(organizationActions.action.loadListOrganization(loadType))
      },
  }
} 

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(userProfileStyles)(UserProfile))